import { render, staticRenderFns } from "./QuestionItemPdf.vue?vue&type=template&id=a0ccaf5e&scoped=true&"
import script from "./QuestionItemPdf.vue?vue&type=script&lang=js&"
export * from "./QuestionItemPdf.vue?vue&type=script&lang=js&"
import style0 from "./QuestionItemPdf.vue?vue&type=style&index=0&id=a0ccaf5e&prod&lang=css&"
import style1 from "./QuestionItemPdf.vue?vue&type=style&index=1&id=a0ccaf5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ccaf5e",
  null
  
)

export default component.exports